import ajaxService from "AjaxService";
import global from "Global";
import type { ThemeContext } from "../VueComponents/ThemeConfigurationDialog";

export interface Theme {
  id: string;
  name: string;
  themeContext: ThemeContext;
  portalPK?: string;
  hostname?: string;
  organizationCode?: string;
  departmentCode?: string;
  branchCode?: string;
  companyCode?: string;
  createdByUser?: string;
  lastEditedByUser?: string;
  createdDateTime?: Date;
  lastEditedDateTime?: Date;
  configuration?: ThemeConfiguration;
}

interface ThemeConfiguration {
  colors?: ThemeColors;
  logoLightImage?: string;
  logoLightImageFileType?: string;
  logoDarkImage?: string;
  logoDarkImageFileType?: string;
  density?: string;
  themeVersion?: number;
  supplyVersion?: number;
}

interface ThemeColors {
  light?: ThemeColorOptions;
  dark?: ThemeColorOptions;
}

interface ThemeColorOptions {
  app?: ApplicationColorOptions;
  primary?: string;
}

interface ApplicationColorOptions {
  brandColor?: string;
  brandColorDark?: boolean;
  brandLoginColor?: string;
  brandLoginColorDark?: boolean;
}

export class BrandingService {
  constructor() {}

  async getAllThemesAsync(): Promise<Theme[]> {
    const url = `${global.serviceUri}api/branding/themes`;
    const result = await ajaxService.getAsync<Theme[]>(url);

    return result;
  }

  getThemeAsync(id: string): Promise<Theme | undefined> {
    const url = `${global.serviceUri}api/branding/themes/${id}`;
    return ajaxService.getAsync<Theme>(url);
  }

  createThemeAsync(theme: Theme): Promise<Theme> {
    const url = `${global.serviceUri}api/branding/themes`;
    return ajaxService.postAsync<Theme>(url, theme);
  }

  updateThemeAsync(theme: Theme): Promise<void> {
    const url = `${global.serviceUri}api/branding/themes/${theme.id}`;
    return ajaxService.putAsync(url, theme);
  }

  async getThemeConfigurationAsync(themeId: string): Promise<ThemeConfiguration> {
    const url = `${global.serviceUri}api/branding/themes/${themeId}/config`;
    const result = await ajaxService.getAsync<ThemeConfiguration>(url);
    return result;
  }

  updateThemeConfigurationAsync(themeId: string, themeOptions: ThemeConfiguration): Promise<void> {
    const url = `${global.serviceUri}api/branding/themes/${themeId}/config`;
    return ajaxService.putAsync(url, themeOptions);
  }

  async fetchCurrentUserThemeAsync(): Promise<Theme | undefined> {
    const modulePK = global.portalInfo.modulePK;
    const uri = `${global.serviceUri}api/branding/themes/user/config`;
    const result = await ajaxService.getAsync<Theme | null>(uri, { modulePK });
    return result ?? undefined;
  }
}

export default new BrandingService();
